import { Box, Text, Grid, chakra, useBreakpointValue } from '@chakra-ui/react';
import { formatNumber } from '../../utils/helper';

const MarksAmountInfo = ({ farming, holding, gasMarks }) => {
	// Function to render each block with title and value
	const isMobile = useBreakpointValue({ base: true, md: false });

	const renderBlock = (title, value) => (
		<Box
			p={4}
			backgroundColor="#FEF0DD"
			borderRadius="lg"
			textAlign="center"
			minW={"80px"}
		>
			{/* Wrapper for title and value with flex layout */}
			<Box display="flex" flexDirection="column" alignItems="center">
				{/* Title with tooltip above the icon */}
				<Text fontSize={!isMobile ? "16px" : "14px"} display="flex" justifyContent="center" alignItems="center" pb={1}>
					{title}
					{/* {title === 'Layerbank' && (
						<Tooltip label="These data are not included in the ranking and may not be final." aria-label="Layerbank Info" placement="top">
							<Icon as={InfoIcon} ml={2} color="gray.500" />
						</Tooltip>
					)} */}
				</Text>
				{/* Number styled to align baseline with text */}
				<Box display="flex" alignItems="baseline" justifyContent="center">
					<chakra.span color="#FF684B" fontWeight="bold" fontSize={!isMobile ? "20px" : "14px"} lineHeight="1">
						{formatNumber(parseFloat(value).toFixed(2))}
					</chakra.span>
				</Box>
			</Box>
		</Box>
	);

	// Filter non-zero farming and holding entries
	const filteredFarming = Object.entries(farming).filter(
		([, project]) => project.marks.some(mark => mark.marks > 0)
	);
	const filteredHolding = Object.entries(holding).filter(
		([, asset]) => asset.points.some(point => point.points > 0)
	);

	return (
		<Box p={5}>
			<Grid
				templateColumns={{ base: 'repeat(auto-fit, minmax(120px, 1fr))' }}
				gap={4}
			>
				{filteredHolding.map(([assetName, asset]) =>
					renderBlock(assetName, asset.points[asset.points.length - 1].points) // Display the latest points for each holding asset
				)}
				{filteredFarming.map(([projectName, project]) =>
					renderBlock(projectName, project.marks[project.marks.length - 1].marks) // Display the latest marks for each farming project
				)}
				{renderBlock('Gas Marks', gasMarks)} {/* Gas marks block */}
			</Grid>
		</Box>
	);
};

export default MarksAmountInfo;
